<template>
    <gz-auth-view-template :bc="false" contentClass="gz-auth-view-template__content_inner">
        <section slot="filters" class="gz-filters">
            <gz-input-container 
                type="filter"
                class="gz-filter__item"    
            >
                <input type="text" v-model="filters.name" class="gz-text-input" placeholder="Поиск по имени">
            </gz-input-container>
        </section>  
              
        <section slot="content">
            <UserRow 
                v-for="(item, $index) in dataComputed"
                :key="$index"
                :data="item"
            />
            <infinite-loading 
                :identifier="infiniteId" 
                @infinite="infiniteHandler"
            ></infinite-loading>
        </section>        
    </gz-auth-view-template>
</template>

<script>
import UserRow from '@/components/custom/admin/views/users/BaseUserRow'

export default {
    name: 'UsersList',
    
    components: {
        UserRow
    },
    data() {
        return {
            filters: {
                name: ''
            },
            responseData: [],
            suggestionResult: [],
            //Pagination
            page: 0,
            infiniteId: +new Date()
        }
    },
    computed: {
        dataComputed() {
            return this.responseData
        }
    },
    methods: {
        infiniteHandler($state) {            
            this.$axios('userview', {
                params: {
                    pg: this.page, 
                    batch: 10,
                    name: this.filters.name,
                    role: 'USER'
                }
            })
            .then(({data}) => {
                if (data.data.length) {
                    this.page += 1
                    this.responseData.push(...data.data)
                    $state.loaded()
                } else {
                    $state.complete()
                }
            })
            .catch(err => {
                console.error('Ошибка вывода списка объектов: ', err)
            })
        },
        suggestions(param) {
            let input = event.target.value
            
            if (input.length >= 2) {
                setTimeout(() => {
                    this.$axios({
                        method: 'GET',
                        url: 'userview',
                        params: {
                            pg: 0,
                            batch: 10,
                            [param]: input
                        }
                    })
                    .then(response => {
                        this.suggestionResult = []
                        
                        let x = []
                        response.data.data.forEach(item => {
                            x.push(item.attributes.lname + ' ' + item.attributes.fname)
                        })

                        this.suggestionResult.push({data: x})
                    })
                }, 1000)
            }

            if (input.length < 2) {
                this.suggestionResult = []
            }
        },
        selectSuggestionOnSelect() {
            return  event.target.value || event.target.innerHTML
        }
    },
    watch: {
        filters: {
            handler() {
                if (this.filters.name.length >= 2) {
                    setTimeout(() => {
                        this.page = 0
                        this.responseData = []
                        this.infiniteId += 1
                    }, 300)
                }
                if (!this.filters.name.length) {
                        this.page = 0
                        this.responseData = []
                        this.infiniteId += 1
                }
            },
            deep: true
        } 
    }
}
</script>